module.exports = __webpack_public_path__ + "static/full-blast-steam-logo-black-9d7723a507849f266aa90869f89e9e94.png";